import { IonCard, IonCardContent, IonImg } from '@ionic/react';
import { Tab, Tabs } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { NavLink, useHistory, useParams } from 'react-router-dom';
import { EventType } from '../../models/EventType';
import { RootState } from '../../models/RootState';
import { SelectedObj } from '../../models/ExchangeSportsState';
import backArrow from '../../assets/images/icons/back-arrow.png';
import {
  setExchEvent,
  setCompetition,
  fetchEventsByCompetition,
  getEventsListByCompetition,
} from '../../store';
import './ExchEventsListMenu.scss';

type StoreProps = {
  eventsList: EventType[];
  selectedEventType: SelectedObj;
  selectedCompetition: SelectedObj;
  selectedEvent: SelectedObj;
  fetchEventsByCompetition: (
    eventTypeId: string,
    competitionId: string
  ) => void;
  setExchEvent: (event: SelectedObj) => void;
  setCompetition: (competition: SelectedObj) => void;
  langData : any;
};
type RouteParams = {
  eventId: string;
};

const EventsListMenu: React.FC<StoreProps> = (props) => {
  const {
    eventsList,
    selectedEventType,
    selectedCompetition,
    selectedEvent,
    fetchEventsByCompetition,
    setExchEvent,
    setCompetition,
    langData
  } = props;
  const [tabValue, setTabValue] = useState<number>(0);
  const { eventId } = useParams<RouteParams>();
  // console.log(useParams());
  const history = useHistory();

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabValue(newValue);
  };

  const handleEventChange = (e: EventType) => {
    setExchEvent({ id: e.id, name: e.name, slug: e.slug });
  };

  useEffect(() => {
    // console.log(eventsList);
    if (!eventsList) {
      fetchEventsByCompetition(selectedEventType.id, selectedCompetition.id);
    } else {
      if (!eventId) {
        handleEventChange(eventsList[0]);
        history.push(
          `/exchange_sports/${selectedEventType.slug}/${
            selectedCompetition.slug
          }/${eventsList[0].slug}/${btoa(
            `${selectedEventType.id}:${selectedCompetition.id}:${eventsList[0].id}`
          )}`
        );
      }
      for (let i = 0; i < eventsList.length; i += 1) {
        if (eventsList[i].slug === selectedEvent.slug && i !== tabValue) {
          setTabValue(i);
          break;
        }
      }
    }
  }, [eventsList, selectedEvent]);

  return (
    <div className="eventsList-menu">
      <IonCard className="eventsList-menu-card">
        <IonCardContent className="eventsList-menu-card-content">
          <NavLink
            className="eventsList-menu-nav-link notactive"
            to={`/exchange_sports/${selectedEventType.slug}`}
            onClick={() => setCompetition({ id: '', name: '', slug: '' })}
          >
            <Tab
              className="eventsList-menu-tab"
              icon={<IonImg className="back-arrow-icon" src={backArrow} />}
              label={langData?.[selectedEventType.name.toLowerCase()]}
              value={1}
            />
          </NavLink>
          <NavLink
            className="eventsList-menu-nav-link"
            to={`/exchange_sports/${selectedEventType.slug}/${selectedCompetition.slug}`}
          >
            <Tab
              className="eventsList-menu-tab"
              label={selectedCompetition.name}
              value={1}
            />
          </NavLink>
          {eventsList ? (
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={tabValue}
              onChange={handleTabChange}
              aria-label="EventsTypes Menu"
              className="eventsList-menu-tabs"
              scrollButtons="off"
            >
              {eventsList.map((e, idx) => (
                <NavLink
                  className="eventsList-menu-nav-link"
                  key={e.slug + '-link' + idx}
                  onClick={() => handleEventChange(e)}
                  to={`/exchange_sports/${selectedEventType.slug}/${
                    selectedCompetition.slug
                  }/${e.slug}/${btoa(
                    `${selectedEventType.id}:${selectedCompetition.id}:${e.id}`
                  )}`}
                >
                  <Tab
                    className="eventsList-menu-tab"
                    label={e.name}
                    value={idx}
                    key={e.slug + '-tab'}
                  />
                </NavLink>
              ))}
            </Tabs>
          ) : null}
        </IonCardContent>
      </IonCard>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  const selectedEventType = state.exchangeSports.selectedEventType;
  const selectedCompetition = state.exchangeSports.selectedCompetition;
  return {
    eventsList: getEventsListByCompetition(
      state.exchangeSports.events,
      selectedEventType.id,
      selectedCompetition.id
    ),
    selectedEventType: selectedEventType,
    selectedCompetition: selectedCompetition,
    selectedEvent: state.exchangeSports.selectedEvent,
    langData:state.common.langData,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setExchEvent: (event: SelectedObj) => dispatch(setExchEvent(event)),
    setCompetition: (competition: SelectedObj) =>
      dispatch(setCompetition(competition)),
    fetchEventsByCompetition: (eventTypeId: string, competitionId: string) =>
      dispatch(fetchEventsByCompetition(eventTypeId, competitionId, [])),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EventsListMenu);
